<div class="obg-m-geofencing-alert-permission">
	<mat-spinner diameter="50"></mat-spinner>
</div>
